module.exports = __webpack_public_path__ + "static/img/hazq-bg.3b8672c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hazq-bg.png
// module id = HZkc
// module chunks = 3